import { styled } from '@mui/material/styles';
import {
  Container as MuiContainer,
  Box as MuiBox,
} from '@mui/material';

const Container = styled(MuiContainer)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 3),
  },
}));

const Box = styled(MuiBox)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export {
  Container,
  Box,
};
